// Generate 100 levels, each with 5 sets. Reps start at 1 and increase by 1 every level.
export function getProgressionLevels() {
  const levels = [];
  
  for (let i = 0; i < 100; i++) {
    const base = i + 1; // Level 1 is 1-1-1-1-1, Level 9 is 9-9-9-9-9, etc.
    
    // Use a flat pattern, as Sets 1-4 are fixed targets and Set 5 is the AMRAP baseline
    const reps = [base, base, base, base, base];
    
    const totalReps = reps.reduce((sum, rep) => sum + rep, 0);
    
    levels.push({
      id: `level_${i+1}`,
      name: `Level ${i+1}`,
      reps,
      totalReps, // Add total reps for display
      index: i
    });
  }
  return levels;
}

export function getLevelLabel(index) {
  if (index < 10) return 'Beginner';
  if (index < 25) return 'Intermediate';
  if (index < 40) return 'Advanced';
  return 'Elite';
} 